import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';
import React from 'react';
import { FormControlProps } from 'react-bootstrap/FormControl';
import { BsForm, InputProps, parseInputProps } from '../../../../components/form/base';
import { DecoratedFormUnit } from '../../base/DecoratedFormUnit';

export type TextAreaInputProps = InputProps<'textarea'> & object;

const defaultProps = {};

export function TextAreaInput(props: TextAreaInputProps) {
  const { inputProps, unitProps } = parseInputProps(props);

  return (
    <DecoratedFormUnit {...unitProps} id={props.id}>
      <BsForm.Control
        isInvalid={!!unitProps.error}
        as="textarea"
        {...(inputProps as FormControlProps)}
      />
    </DecoratedFormUnit>
  );
}

TextAreaInput.defaultProps = defaultProps;

export function TextAreaField(props: React.ComponentProps<typeof TextAreaInput>) {
  const { name, ...rest } = props;

  return (
    <Field name={name}>
      {(fp: FieldProps) => {
        return (
          <TextAreaInput
            {...fp.field}
            {...rest}
            error={fp.meta.touched && fp.meta.error}
            disabled={rest.disabled || fp.form.isSubmitting}
          />
        );
      }}
    </Field>
  );
}
